import { getQueryParam } from '@vfde-sails/utils';
import { CATEGORY_QUERYPARAM } from 'Constant';

/**
 * Get all filters from URL
 */
export const getCategoriesFromUrl = (): string[] => {
    const categories = getQueryParam(CATEGORY_QUERYPARAM);

    if (categories) {
        const sanitizedFilters = categories.replace(/[^\w|,*]/gi, '');

        return sanitizedFilters.split(',');
    }

    return [];
};
